import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { HttpClient } from "../../utils/HttpClient";

import "./SearchForm.css";

const SearchForm = ({ onSearch }) => {
  const navigate = useNavigate();
  const [propertyType, setPropertyType] = useState("");
  const [type, setType] = useState("");
  const [location, setLocation] = useState("");
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [propertyTypeDropdownVisible, setPropertyTypeDropdownVisible] =
    useState(false);
  const [typeDropdownVisible, setTypeDropdownVisible] = useState(false);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [regions, setRegions] = useState([]);
  const dropdownRef = useRef(null);
  const propertyTypeRef = useRef(null);
  const typeRef = useRef(null);

  const propertyTypes = [
    { value: "apartment/flat", label: "Apartment/Flat" },
    { value: "house", label: "House" },
    { value: "vacant land/plot", label: "Vacant Land/Plot" },
    { value: "townhouse", label: "Townhouse" },
    { value: "industrial property", label: "Industrial Property" },
    { value: "commercial property", label: "Commercial Property" },
    { value: "farm", label: "Farm" },
  ];

  const types = [
    { value: "rent", label: "To Rent" },
    { value: "sale", label: "For Sale" },
  ];

  useEffect(() => {
    const httpClient = new HttpClient();
    const fetchRegions = async () => {
      try {
        const response = await httpClient.get("/properties/regions");
        console.log("Fetched regions:", response.data);
        setRegions(response.data.data);
      } catch (error) {
        console.error("Failed to fetch regions:", error);
      }
    };

    fetchRegions();
  }, []);

  const handleLocationClick = () => {
    setDropdownVisible(!dropdownVisible);
    setFilteredOptions(regions);
  };

  const handleOptionClick = (option) => {
    setLocation(option);
    setDropdownVisible(false);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const params = new URLSearchParams({
      property_type: type,
      category: propertyType,
      location,
    }).toString();

    navigate(`/properties?${params}`);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownVisible(false);
      }
      if (
        propertyTypeRef.current &&
        !propertyTypeRef.current.contains(event.target)
      ) {
        setPropertyTypeDropdownVisible(false);
      }
      if (typeRef.current && !typeRef.current.contains(event.target)) {
        setTypeDropdownVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <form className="search-form hero-search" onSubmit={handleSubmit}>
      <div className="search-form-container">
        {/* Property Type Dropdown */}
        <div className="dropdown" ref={propertyTypeRef}>
          <div
            className={`input-section${propertyType ? " selected" : ""}`}
            onClick={() =>
              setPropertyTypeDropdownVisible(!propertyTypeDropdownVisible)
            }
          >
            {propertyType
              ? propertyTypes.find((p) => p.value === propertyType)?.label
              : "Category"}
          </div>

          {propertyTypeDropdownVisible && (
            <div className="dropdown-options">
              <div
                className="dropdown-option"
                onClick={() => {
                  setPropertyType("");
                  setPropertyTypeDropdownVisible(false);
                }}
              >
                Category
              </div>
              {propertyTypes.map((pType) => (
                <div
                  key={pType.value}
                  className="dropdown-option"
                  onClick={() => {
                    setPropertyType(pType.value);
                    setPropertyTypeDropdownVisible(false);
                  }}
                >
                  {pType.label}
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Type Dropdown */}
        <div className="dropdown" ref={typeRef}>
          <div
            className={`input-section${type ? " selected" : ""}`}
            onClick={() => setTypeDropdownVisible(!typeDropdownVisible)}
          >
            {type ? types.find((t) => t.value === type)?.label : "Type"}
          </div>

          {typeDropdownVisible && (
            <div className="dropdown-options">
              <div
                className="dropdown-option"
                onClick={() => {
                  setType("");
                  setTypeDropdownVisible(false);
                }}
              >
                Type
              </div>
              {types.map((t) => (
                <div
                  key={t.value}
                  className="dropdown-option"
                  onClick={() => {
                    setType(t.value);
                    setTypeDropdownVisible(false);
                  }}
                >
                  {t.label}
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Location Dropdown */}
        <div className="dropdown" ref={dropdownRef}>
          <div
            className={`input-section${location ? " selected" : ""}`}
            onClick={handleLocationClick}
          >
            {location || "Select Location"}
          </div>

          {dropdownVisible && (
            <div className="dropdown-options">
              {filteredOptions.length > 0 ? (
                filteredOptions.map((option, index) => (
                  <div
                    key={index}
                    className="dropdown-option"
                    onClick={() => handleOptionClick(option)}
                  >
                    {option}
                  </div>
                ))
              ) : (
                <div className="dropdown-option">No locations found</div>
              )}
            </div>
          )}
        </div>

        <button className="search-button modern-search-btn" type="submit">
          Search
        </button>
      </div>
    </form>
  );
};

export default SearchForm;
